import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationGeofencingCountryEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = null;
        this.geoCountryId = null;
        this.geoCountryName = null;
        this.isBlocked = false;
        this.organizationGeofencingCountryId = null;
        this.organizationId = null;
        this.overrideAllowed = false;
    }
    pk() {
        var _a;
        return (((_a = this.organizationGeofencingCountryId) === null || _a === void 0 ? void 0 : _a.toString()) ||
            btoa(JSON.stringify(this)));
    }
}
OrganizationGeofencingCountryEntity.schema = {
    creationDTTM: ISODate
};
OrganizationGeofencingCountryEntity.key = 'OrganizationGeofencingCountry';
export { OrganizationGeofencingCountryEntity };
